import { render, staticRenderFns } from "./RewardTrfCustom.vue?vue&type=template&id=69f8934a&"
import script from "./RewardTrfCustom.vue?vue&type=script&lang=js&"
export * from "./RewardTrfCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports